<template>
    <ul>
        <li v-for="(item, i) in props.templates" :key="item.id"
            class="flex items-center gap-5 py-4 hover:bg-neutral-100 dark:border-neutral-700 dark:hover:bg-gray-600 transition-all hover:rounded-xl -mx-2 cursor-pointer hover:border-transparent px-2"
            @click="router.visit('/app/notifications/' + item.id)"
            :class="[
                currentId === item.id
                    ? 'bg-white hover:bg-white/80 dark:hover:bg-gray-700 dark:bg-gray-800 border-transparent shadow rounded-xl'
                    : 'border-t first:border-t-0',
                props.templates[i - 1] && props.templates[i - 1].id === currentId
                    ? 'border-t-transparent dark:border-t-transparent'
                    : '',
                props.templates[i] && props.templates[i].id === currentId
                    ? 'border-t-transparent dark:border-t-transparent'
                    : ''
            ]"
        >
            <div
                class="bg-gray-100 dark:bg-neutral-700 p-2 py-0.5 rounded-lg"
                :class="[
                        'pi text-lg',
                        {
                            'pi-asterisk text-sky-500 bg-sky-50': item.type === 'new_client',
                            'pi-thumbs-up text-green-500 bg-green-50': item.type === 'confirm_client',
                            'pi-calendar text-amber-600 bg-amber-100/80': item.type === 'change_client',
                            'pi-calendar-times text-red-500 bg-red-50': item.type === 'cancel_client',
                            'pi-bell text-yellow-600 bg-yellow-50': item.type === 'reminder_client',
                        }
                    ]"
            ></div>
            <div class="opacity-90 grow">
                <h5 class="font-semibold">
                    <template v-if="item.type === 'new_client'">{{ $t('reservations.notify_new_client') }}</template>
                    <template v-else-if="item.type === 'confirm_client'">{{ $t('reservations.notify_confirm') }}</template>
                    <template v-else-if="item.type === 'change_client'">{{ $t('reservations.notify_change') }}</template>
                    <template v-else-if="item.type === 'cancel_client'">{{ $t('reservations.notify_cancel') }}</template>
                    <template v-else-if="item.type === 'reminder_client'">{{ $t('reservations.notify_reminder') }}</template>
                    <template v-else-if="item.type === 'retargeting_client'">{{ $t('reservations.notify_retargeting') }}</template>
                    <template v-else>{{ $t('reservations.notify_unknown') }}</template>
                </h5>
                <p class="text-sm opacity-70">
                    <template v-if="item.type === 'new_client'">{{ $t('reservations.notify_new_client_desc') }}</template>
                    <template v-else-if="item.type === 'confirm_client'">{{ $t('reservations.notify_confirm_desc') }}</template>
                    <template v-else-if="item.type === 'change_client'">{{ $t('reservations.notify_change_desc') }}</template>
                    <template v-else-if="item.type === 'cancel_client'">{{ $t('reservations.notify_cancel_desc') }}</template>
                    <template v-else-if="item.type === 'reminder_client'">{{ $t('reservations.notify_reminder_desc') }}</template>
                    <template v-else-if="item.type === 'retargeting_client'">{{ $t('reservations.notify_retargeting_desc') }}</template>
                    <template v-else>{{ $t('reservations.notify_unknown') }}</template>
                </p>
            </div>
            <div class="text-xs text-nowrap flex flex-col gap-2 w-1/5 opacity-90">
                <div class="flex items-center gap-1">
                    <span class="pi pi-envelope !text-xs" :class="item.state ? 'text-green-500' : 'text-red-500'"></span>
                    <span>{{ item.state ? $t('reservations.notify_sends_email') : $t('reservations.notify_nosends_email') }}</span>
                </div>
                <div class="flex items-center gap-1 ">
                    <span class="pi pi-mobile !text-xs" :class="item.state_sms ? 'text-green-500' : 'text-red-500'"></span>
                    <span>{{ item.state_sms ? $t('reservations.notify_sends_sms') : $t('reservations.notify_nosends_sms') }}</span>
                </div>
            </div>


            <div class="-mr-2">
                <Button icon="pi pi-chevron-right" text severity="secondary" rounded size="small"/>
            </div>
        </li>
    </ul>
</template>

<script setup>
import Button from 'primevue/button';
import {router, usePage} from "@inertiajs/vue3";

const props = defineProps({
    templates: Array,
    reservationForms: Array,
    form: String,
    currentId: Number,
})
</script>
<style scoped lang="scss">
</style>
